import { ProcessoCadastro } from "./processo-cadastro";

export interface ProcessoPreCadastroCliente {
  NCODIGO: number;
  NCODIGOPROCESSOCADASTRO: number;
  CA1COD: string;
  CA1LOJA: string;
  CA1NOME: string;
  CA1NREDUZ: string;
  CA1CONTATO: string;
  CA1TIPO: string;
  DA1DTNASC: Date | undefined;
  NA1LC: number;
  CA1CEP: string;
  CA1END: string;
  CA1COMPLEM: string;
  CA1BAIRRO: string;
  CA1EST: string;
  CA1ESTADO: string;
  CA1COD_MUN: string;
  CA1MUN: string;
  CA1CGC: string;
  CA1INSCR: string;
  CA1INSCRM: string;
  CA1DDD: string;
  CA1TEL: string;
  CA1NATUREZ: string;
  CA1CONTA: string;
  CA1EMAIL: string;
  CA1CODPAIS: string;
  CA1PAIS: string;
  CA1FAX: string;
  CA1HPAGE: string;
  CA1PESSOA: string;
  CA1RG: string;
  CA1GRPTRIB: string;
}

export const defaultProcessoPreCadastroCliente = (): ProcessoPreCadastroCliente => {
  return {
    NCODIGO: 0,
    NCODIGOPROCESSOCADASTRO: 0,
    CA1COD: '',
    CA1LOJA: '',
    CA1NOME: '',
    CA1NREDUZ: '',
    CA1CONTATO: '',
    CA1TIPO: '',
    DA1DTNASC: undefined,
    NA1LC: 0,
    CA1CEP: '',
    CA1END: '',
    CA1COMPLEM: '',
    CA1BAIRRO: '',
    CA1EST: '',
    CA1ESTADO: '',
    CA1COD_MUN: '',
    CA1MUN: '',
    CA1CGC: '',
    CA1INSCR: '',
    CA1INSCRM: '',
    CA1DDD: '',
    CA1TEL: '',
    CA1NATUREZ: '',
    CA1CONTA: '',
    CA1EMAIL: '',
    CA1CODPAIS: '',
    CA1PAIS: '',
    CA1FAX: '',
    CA1HPAGE: '',
    CA1PESSOA: '',
    CA1RG: '',
    CA1GRPTRIB: '',
  };
};

export interface ProcessoPreCadastroClienteListaItem {
  NPROCESSOCODIGO: number;
  NCODIGO: number;
  CSTATUS: string;
  CCHAVE: string;
  CURGENTE: string;
  CA1COD: string;
  CA1LOJA: string;
  CA1NOME: string;
  CUSRID: string;
  CUSRNOME: string;
  DINCLUSAO: Date | undefined;
  DFINALIZACAO: Date | undefined;
}

export const defaultProcessoPreCadastroClienteListaItem = (): ProcessoPreCadastroClienteListaItem => {
  return {
    NPROCESSOCODIGO: 0,
    NCODIGO: 0,
    CSTATUS: '',
    CCHAVE: '',
    CURGENTE: '',
    CA1COD: '',
    CA1LOJA: '',
    CA1NOME: '',
    CUSRID: '',
    CUSRNOME: '',
    DINCLUSAO: undefined,
    DFINALIZACAO: undefined,
  };
};

export interface ProcessoPreCadastroClienteLista {
  items: Array<ProcessoPreCadastroClienteListaItem>;
  hasNext: boolean;
}

export const defaultProcessoCadastroDtoList = (): ProcessoPreCadastroClienteLista => {
  return {
    items: [],
    hasNext: false,
  };
};

export interface ProcessoPreCadastroClienteDto {
  CLIENTE: ProcessoPreCadastroCliente;
  CHISTORICO: string;
  CDECISAO: string;
  CURGENTE: string;
}
